import {createAction, props} from '@ngrx/store';
import {ExceptionResponse} from '@shared/dto';
import {AnalyticsState} from './analytics.reducer';

export const getAnalyticsDailyProgress = createAction('@app/analytics/get/daily-progress', props<{ memberId: number }>());
export const setAnalyticsDailyProgress = createAction('@app/analytics/set/daily-progress', props<Pick<AnalyticsState, 'dailyProgress'>>());

export const getDataFailure = createAction('@app/analytics/get/failure', props<{ error: Error | ExceptionResponse}>());
